import { Component, OnInit, Input, ViewChild } from '@angular/core';

import { ConfirmationService, MenuItem } from 'primeng/api';
import { MessageService } from 'primeng/api';

// Export
import * as FileSaver from 'file-saver';
import { ExportService } from 'src/app/shared/services/export.service';

// Model
import { Table } from 'primeng/table';
import { BinLocationCrudService, BinLocationCrudService as LocationCrudService } from 'src/app/shared/services/bin-location-crud.service';
import { BinLocation as Location } from 'src/app/shared/interfaces/bin-location';

@Component({
  selector: 'app-bin-locations',
  templateUrl: './bin-locations.component.html',
  styleUrls: ['./bin-locations.component.scss']
})
export class BinLocationsComponent implements OnInit {

 
  locations: Location[];
  location: Location;
  selectedLocations: Location[] = [];

  locationDialog: boolean = false;

  submitted: boolean = false;

  // column management
  cols: any[] = [];
  _selectedColumns: any[] = [];

  // export
  @ViewChild('dt', {static: true}) dt : any;
  exportColumns: any[] = [];

  // ui beadcrumb
  breadcrumbs: MenuItem[];
  homeBreadcrumb: MenuItem = {} as MenuItem;

  hideWhenNoPallet: boolean = false;
  noData: boolean = false;
  preLoader: boolean = true;

  separatorExp: string = "[,| ]";

  constructor(
    private locationService : BinLocationCrudService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private exportService: ExportService
  ) { 
    // ui breadcrumbs
    this.breadcrumbs = [
      {label: 'Bin Management'},
      {label: 'Locations (Bins)'}
    ];

    this.locations = [];
    this.location = { } as Location ;
  }

  ngOnInit(): void {

    this.isFilter = false;
    
    this.dataState();
    let s = this.locationService.getLocationsList(); 
    s.snapshotChanges().subscribe(data => {
      this.locations = [];
      data.forEach(item => {
        let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
        if (jsonItem) {
          if (jsonItem) {
            jsonItem['$key'] = item.key;
          }
          let l : Location = jsonItem as Location;
          if (l.tags) {
            l.tags = Object.values(l.tags);
          }
          this.locations.push(l);
        }
      })
    })

    // column management
    this.cols = [
      { field: 'name', header: 'Name' },
      { field: 'qrcode', header: 'QRCode' },
      { field: 'description', header: 'Description' },
      { field: 'tags', header: 'Tags' },
      { field: 'isEnabled', header: 'Enabled' },
      { field: 'actions', header: 'Actions' } 
    ];

    // column that we shoa at the beginning
    this._selectedColumns = this.cols;
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'description');
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'isEnabled');

    // Exports
   // this.exportColumns = this.cols.map(col => ( {title: col.header, dataKey: col.field} ) );
   // For the PDF 
   this.exportColumns = this.cols.map(col => {
      if (col.field === 'position' || col.field === 'rank')  
        return {title: col.header, dataKey: 'position'};
      if (col.field !== 'actions')  
        return {title: col.header, dataKey: col.field};
      return {};
    } );
  }

  dataState() {     
    this.locationService.getLocationsList().valueChanges().subscribe(data => {
      this.preLoader = false;
      if(data.length <= 0){
        this.hideWhenNoPallet = false;
        this.noData = true;
      } else {
        this.hideWhenNoPallet = true;
        this.noData = false;
      }
    })
  }

  includesCol(val: string) : boolean{
    let c = this._selectedColumns.find(c => c.field === val);
    return c;
  }

  // Column management
  @Input() get selectedColumns(): any[] {
    // console.log('selected columns', this._selectedColumns);
    return this._selectedColumns;
  }
  set selectedColumns(val: any[]) {
    //restore original order
    // console.log('before selected columns', this._selectedColumns);
    // console.log('before cols', this._selectedColumns);
    this._selectedColumns = this.cols.filter(col => val.includes(col));
    // console.log('after selected columns', this._selectedColumns);
  }

  // Export management
  exportPdf() {
    import("jspdf").then(jsPDF => {
        import("jspdf-autotable").then(x => {
            const doc = new jsPDF.default('l','pt');
            // @ts-ignore
            doc.autoTable(this.exportColumns, this.locations);
            doc.save('locations.pdf');
        })
    })
  }

  exportExcel() {
    import("xlsx").then(xlsx => {
        const worksheet = xlsx.utils.json_to_sheet(this.locations);
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, "locations");
    });
  }

  exportDTCSV() {
    console.log('export csv');
    this.dt.exportCSV();
  }

  exportToCsv(): void {
    let exportCols : string[] = [];
    this.selectedColumns.forEach( sc => 
      { exportCols.push(sc.field);
        console.log('SAVEC CSV COL F ',sc.field);
        console.log('SAVEC CSV COL ',sc);
      });
      exportCols.push('position');
      console.log('SAVEC CSV SELECTED LOCATIONS ', this.selectedLocations);
      console.log('SAVEC CSV LOCATIONS ', this.locations);
      console.log('SAVEC CSV EXPORT COL ', exportCols);
      this.exportService.exportToCsv(this.selectedLocations, 'locations', exportCols);
   // this.exportService.exportToCsv(this.locations, 'locations', ['$key', 'name', 'description', 'tags', 'isEnabled', 'actions']);
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  // CRUD management
  openNew() {
    this.location = {} as Location;
    this.submitted = false;
    this.locationDialog = true;
  }

  deleteSelectedLocations() {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete the selected locations?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.locations = this.locations.filter(val => !this.selectedLocations.includes(val));
            
            this.selectedLocations.forEach( location => this.locationService.deleteLocation(location.$key));
            this.selectedLocations = [];
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'Locationss Deleted', life: 3000});
        }
    });
  }

  editLocation(location: Location) {
    this.location = {...location};
    this.locationDialog = true;
  }

  deleteLocation(location: Location) {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete ' + location.name + '?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.locations = this.locations.filter(val => val.$key !== location.$key);
            this.location = {} as Location;
            this.locationService.deleteLocation(location.$key);
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'Location Deleted', life: 3000});
        }
    });
  }

  hideDialog() {
    this.locationDialog = false;
    this.submitted = false;
  }

  saveLocation() {
    this.submitted = true;

    if ( this.location.name.trim() ) {
      this.location.isEnabled = true;
      
      if (this.location.$key) {
          this.locations[this.findIndexById(this.location.$key)] = this.location;                
          this.messageService.add({severity:'success', summary: 'Successful', detail: 'Location Updated', life: 3000});
          this.locationService.updateLocation(this.location);
        } else {
          this.location.position = this.locations.length;
          this.locationService.addLocation(this.location);
      }
      this.messageService.add({severity:'success', summary: 'Successful', detail: 'Location Created', life: 3000});
      this.locations = [...this.locations];
    }

    this.locationDialog = false;
    this.location = { } as Location;
  }

  findIndexById(id: string): number {
    let index = -1;
    for (let i = 0; i < this.locations.length; i++) {
        if (this.locations[i].$key === id) {
            index = i;
            break;
        }
    } 
    return index;
  }

  filter( dt : Table, event : {target: any} ) {
    dt.filterGlobal( (event.target as HTMLInputElement).value, 'contains')
  }

  completeLocation(location : Location) {
    //console.log("SAVE", location);
    this.locationService.updateLocation(location);
  }

  completePosition(location : Location) {
    console.log("SAVE", location);
  //  this.locationService.updateLocation(location);


    if ( this.newPosition > -1 ) {
        location.position = this.newPosition;
        location = this.checkPositionLimits(location);
        this.reorderElements(location);
        //this.updateDB(spray);
        this.newPosition = -1;
        this.previousPosition = -1;
        return;
      }
  }


  @ViewChild('dt') tableElement: any; // already dt above
  isReordering : boolean = false;
  isAscReordering : boolean = false;
  isFilter : boolean = false;

  // Reorder
  reorder(event: any) {
    //console.log('Reorder event', event);
    // console.log('Before', this.sprays);
    // const myClonedArray = [];
    // this.sprays.forEach(val => myClonedArray.push(Object.assign({}, val)));
    // console.log('Before2', myClonedArray);
    if (event.dragIndex === event.dropIndex ) {
      return;
    }
    const startIndex = this.isAscReordering? event.dragIndex : this.locations.length - 1 - event.dragIndex;
    const endIndex   = this.isAscReordering? event.dropIndex : this.locations.length - 1 - event.dropIndex;
    const sprayToMove = this.locations[startIndex];
    
    
    // console.log('StartIndex', startIndex);
    // console.log('EndIndex', endIndex);

    if (startIndex < endIndex) {
      for(let index = startIndex; index < endIndex; index++) {
        this.locations[index] = this.locations[index+1];
        this.locations[index].position = index;
        this.locationService.updateLocation(this.locations[index]);
      }     
    } else {
      for(let index = startIndex; index > endIndex; index--) {
        this.locations[index] = this.locations[index-1];
        this.locations[index].position = index;
        this.locationService.updateLocation(this.locations[index]);
      }
    } 
    this.locations[endIndex] = sprayToMove;
    this.locations[endIndex].position = endIndex;
    this.locationService.updateLocation(this.locations[endIndex]);
  }

  // onFieldEdit(spray: Spray, fieldName: string): void {
  //   //console.log(this.sprays);
  //   console.log("Edit Init Event Called");
  //   console.log('Field name :'+fieldName);
  //   console.log('Field value :' + spray[fieldName]);
  //   if (fieldName === 'position') {
  //     if ( this.newPosition ) {
  //       spray.position = this.newPosition;
  //       spray = this.checkPositionLimits(spray);
  //       this.reorderElements(spray);
  //       //this.updateDB(spray);
  //       this.newPosition = undefined;
  //       this.previousPosition = undefined;
  //       return;
  //     }
      
  //   } else {
  //     this.updateDB(spray);
  //   }
  // }


  ngAfterViewInit() {
    this.dt.onSort.subscribe((data: { field: string; order: number; }) => {
        if (data.field && data.field === "position") {
          this.isReordering = true;
          this.isAscReordering = (data.order == 1);
          // console.log("ASC", this.isAscReordering);
          // console.log("data.order", data.order);
        } else {
          this.isReordering = false;
        }
    });
    this.dt.onFilter.subscribe( (data: {
      filteredValue: {
        [x: string]: any; field: string; order: number; 
}; field: string; order: number; 
}) => {
      if (data && data.filteredValue) {
        this.isFilter = !(this.locations.length === data.filteredValue['length']);
      } else {
        this.isFilter = false;
      }
  });
  
}


  previousPosition : number = -1;
  newPosition : number = -1;

  modelChangeFn(event: number, spray: Location) {
    console.log("event" +event);
    if (spray.position != null && spray.position > -1) {
      this.previousPosition = spray.position;
      this.newPosition = event;
    }
   
    console.log("previous" +this.previousPosition);
    console.log("new" +this.newPosition);
  }

  checkPositionLimits(spray: Location) {
    console.log('check ',spray.position + ' ' + this.locations.length);
    if (!spray.position) {
      console.log('check 1');
      return this.location;
    }
    if (spray.position < 0) {
      spray.position = 0;
      console.log('check 2');
      return spray;
    }
    if (spray.position > this.locations.length) {
      spray.position = this.locations.length - 1;
      console.log('check 3', spray.position);
      return spray;
    }
    console.log('check 4');
    return spray;
  }

  async reorderElements(spray: Location) {
    this.newPosition = this.newPosition  > this.locations.length ? this.locations.length - 1 : this.newPosition;
    this.newPosition = this.newPosition  < 0 ? 0 : this.newPosition;
    if (this.previousPosition === spray.position ) {
      return;
    }
    console.log('Previous position: '+ this.previousPosition);
    console.log('New position: '+ this.newPosition);
    const startIndex = this.previousPosition;
    const endIndex   = this.newPosition;
    const sprayToMove = this.locations[startIndex];
    console.log('Item to move: ', this.locations[startIndex]);
    if (startIndex < endIndex) {
      for(let index = startIndex; index < endIndex; index++) {

        console.log('LOC', this.locations);
        console.log('Item to +1: ', this.locations[index+1]);

        this.locations[index] = this.locations[index+1];
        this.locations[index].position = index;
        console.log('Move: ', this.locations[index+1]);
        console.log('Move pos: ', this.locations[index].position);
        //await this.updateDB(this.sprays[index]);
        this.locationService.updateLocation(this.locations[index]);
        console.log('Update DB: ', this.locations[index]);
      }     
    } else {
      for(let index = startIndex; index > endIndex; index--) {
        this.locations[index] = this.locations[index-1];
        this.locations[index].position = index;
        this.locationService.updateLocation(this.locations[index]);
      }
    } 
    this.locations[endIndex] = sprayToMove;
    this.locations[endIndex].position = endIndex;
    this.previousPosition = -1;
    this.newPosition = -1;
    this.locationService.updateLocation(this.locations[endIndex]);
    
    // const myClonedArray = [];
    // this.sprays.forEach(val => myClonedArray.push(Object.assign({}, val)));
    // this.sprays = myClonedArray;
   // this.getAllRecords();
  }

}
